import React from 'react'
import BookingManagement from '../components/BookingManagement/BookingManagement'

const BookingManagementPage = () => {
  return <BookingManagement />
}

export default BookingManagementPage

